import * as actions from "./DynamicDashboardType";

const INITIAL_STATE = {
    moduleList: [],
    reportsList: [],
    dynamicDropdownList: [],
    reportParams: [],
    reportOutput: {},
    reportAuthorizationList: [],
};

const dynamicReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.SETMODULELIST:
            return {
                ...state,
                moduleList: action.payload,
            };
        case actions.SETREPORTSLIST:
            return {
                ...state,
                reportsList: action.payload,
            };
        case actions.SETDYNAMICDROPDOWNLIST:
                return {
                    ...state,
                dynamicDropdownList: action.payload,
            };
        case actions.SETREPORTPARAMS:
                return {
                    ...state,
                reportParams: action.payload,
            };
        case actions.SETREPORTOUTPUT:
                return {
                    ...state,
                reportOutput: action.payload,
            };
        case actions.SETREPORTAUTHORIZATION:
                return {
                    ...state,
                reportAuthorizationList: action.payload,
        };
        default:
                return state;
    };
};

export default dynamicReportReducer;